import { Typography } from '@mui/material';
import './ChartContainer.scss';

const ChartContainer = ({
  title,
  children,
  isDataAvailable,
  className,
  onClick,
} = {
  title: '',
  isDataAvailable: true,
  children: '',
  className: '',
  onClick: null,
}) => (
  // eslint-disable-next-line
  <div className={`chart-container ${className} ${onClick ? 'clickable' : ''}`} onClick={onClick}>
    {title && (<Typography variant='h6'>{title}</Typography>)}
    {isDataAvailable ? (
      children
    ) : (
      <div className='no-data-container'>
        <Typography variant='h5'>No Data Available</Typography>
      </div>
    )}
  </div>
);

export default ChartContainer;
